import type { FieldResolver } from "@/components/units/EntityHistory/utils/getChanges";

const formatCashbackOverrideTargets = (value: unknown): string | null => {
  if (!Array.isArray(value)) {
    return value === null || value === undefined ? null : String(value);
  }

  return value
    .map(target => {
      if (!target || typeof target !== "object") {
        return String(target);
      }

      const row = target as Record<string, unknown>;

      const relation =
        row.brand && typeof row.brand === "object"
          ? (row.brand as Record<string, unknown>)
          : row.branch && typeof row.branch === "object"
            ? (row.branch as Record<string, unknown>)
            : undefined;

      const name =
        relation?.nameEn ??
        relation?.nameAr ??
        row.nameEn ??
        row.nameAr ??
        row.brandId ??
        row.branchId;

      const type = typeof row.type === "string" ? row.type : null;

      if (!name) {
        return type ?? "Unknown target";
      }

      return type
        ? `${type.charAt(0)}${type.slice(1).toLowerCase()}: ${String(name)}`
        : String(name);
    })
    .join("\n");
};

export const createCashbackOverrideTargetsResolver = (): FieldResolver => ({
  formatValue: formatCashbackOverrideTargets,
});
